import { http } from '@utils/interceptor'
import { URL_CMS_GET_CITY_LIST, URL_CMS_GET_APP_CONFIG } from './constant-config'

export const getCityList = async () => {
  const _temp = await http.get(URL_CMS_GET_CITY_LIST)
  if (_temp.data && _temp.data.cities) {
    return _temp.data.cities
  } else {
    console.error(`Error Warning: cause by ${URL_CMS_GET_CITY_LIST}, request params is `, {}, `and response is`, _temp)
    return {}
  }
}

export const getCmsAppConfig = async () => {
  try {
    const _temp = await http.get(URL_CMS_GET_APP_CONFIG)
    if (_temp.code * 1 === 0) {
      return _temp.data
    } else {
      console.error(`Error Warning: cause by ${URL_CMS_GET_APP_CONFIG}, request params is `, {}, `and response is`, _temp)
      return {}
    }
  } catch (error) {
    console.log('error is ', error)
  }
}




